import { render, staticRenderFns } from "./PaketWisata.vue?vue&type=template&id=2d148cf6"
import script from "./PaketWisata.vue?vue&type=script&lang=js"
export * from "./PaketWisata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports